module.exports = __webpack_public_path__ + "static/media/texto_2.780ce53d.png";